export default __webpack_public_path__ + "static/media/childStickerBackground.836b9686.jpg";